// extracted by mini-css-extract-plugin
var _1 = "Card-module__container--xquSz";
export { _1 as "container" }
